module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc( "LogEntryCreate", "Create new log entry" ) ))==null?'':__t)+
'</legend></fieldset><fieldset><label for="log-entry-input">'+
((__t=( i18n.tc( "LogEntryCreate", "Content:" ) ))==null?'':__t)+
'</label> <span class="remaining-bytes" data-output="remaining-bytes"></span> <textarea id="log-entry-input" name="log-entry-input" maxlength="1021" data-input="entry-content" required></textarea><p class="input" data-text="shift-enter-info"><small>'+
((__t=( i18n.tc( "LogEntryCreate", "Use shift+enter to add linebreaks." ) ))==null?'':__t)+
'</small></p></fieldset><fieldset><span class="label">'+
((__t=( i18n.tc( "LogEntryCreate", "Attach to log for:" ) ))==null?'':__t)+
'</span><div class="input" data-container="entry-array"> ';
 if ( context === "device" ) { 
__p+=' <div><input type="checkbox" id="entry-unit-input" name="entry-unit-input" data-input="entry-unit" checked="checked"> <label class="align-left" for="entry-unit-input">'+
((__t=( i18n.tc( "LogEntryCreate", "Device" ) ))==null?'':__t)+
'</label></div> ';
 if ( hasCustomer ) { 
__p+=' <div><input type="checkbox" id="entry-customer-input" name="entry-customer-input" data-input="entry-customer"> <label class="align-left" for="entry-customer-input">'+
((__t=(i18n.tc( "LogEntryCreate", "Customer" ) ))==null?'':__t)+
'</label></div> ';
 } 
__p+=' ';
 } 
__p+=' ';
 if ( context === "billing") { 
__p+=' <div><input type="checkbox" id="entry-customer-input" name="entry-customer-input" data-input="entry-customer" disabled="disabled" checked="checked"> <label class="align-left" for="entry-customer-input">'+
((__t=( i18n.tc( "LogEntryCreate", "Customer" ) ))==null?'':__t)+
'</label></div> ';
 } 
__p+=' </div></fieldset><fieldset class="button-wrap"><button data-click="log-entry-cancel">'+
((__t=( i18n.tc( "LogEntryCreate", "Cancel" ) ))==null?'':__t)+
'</button> <button class="primary" data-click="log-entry-submit" disabled="disabled">'+
((__t=( i18n.tc( "LogEntryCreate", "Submit" ) ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
